import { Form } from '@models/membership/Form'
import { SBIcon } from '@supplement-bacon/react-toolkit/components'
import { Descriptions, Flex, Space, Typography } from 'antd'
import { Fragment } from 'react/jsx-runtime'
import FormAnswer from '../form-answer/FormAnswer'

const { Title } = Typography
interface Props {
  form: Form | undefined
}

/**
 * This component renders a Form structure with its steps, sections, and items.
 * This is temporary as the form builder will provide its own rendering component in the future.
 */
const FormRender = ({ form }: Props) => {
  if (!form) {
    return <></>
  }

  return form.steps.map((step) => {
    const sections = step.sections || []

    // We don't want to render the plan choice
    if (step.icon === 'ContainerOutlined') {
      return <Fragment key={step.id}></Fragment>
    }

    return (
      <Flex vertical key={step.id} gap={10}>
        <Title level={5} className="m-0">
          <Space>
            <SBIcon name={step.icon} />
            {step.en.title}
          </Space>
        </Title>
        <Flex vertical key={step.id} gap={16}>
          {sections.map((section) => (
            <Descriptions
              key={section.id}
              styles={{ content: { overflow: 'hidden' } }}
              size="small"
              bordered
              items={(section.items ?? [])
                // items={sections
                //   .flatMap((section) => section.items ?? [])
                .map((item) => {
                  /**
                   * The answers stored as attributes on the membership profile
                   * are displayed in the MembershipProfileAvatar component
                   * Therefore, we skip them here to avoid duplication
                   */

                  if (
                    [
                      'plan',
                      'photo',
                      'first_name',
                      'last_name',
                      'email',
                      'phone',
                      'birth_date',
                      'language',
                    ].includes(item.name)
                  )
                    return null

                  const isDeletedItem = item.deletedAt
                  const itemLabel =
                    (isDeletedItem ? '<i>Deleted question</i> - ' : '') +
                    (item?.en.title ?? '')

                  return {
                    key: item.id,
                    span:
                      (JSON.parse(item.colSpan || '{"md": 24}').md * 3) / 24,
                    styles: {
                      label: {
                        opacity: isDeletedItem ? 0.4 : undefined,
                      },
                      content: {
                        opacity: isDeletedItem ? 0.4 : undefined,
                      },
                    },
                    label: (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: itemLabel,
                        }}
                      />
                    ),
                    children:
                      item.answers && item.answers.length > 0 ? (
                        <FormAnswer.Avatar model={item.answers[0]} />
                      ) : (
                        <>--</>
                      ),
                  }
                })
                .filter((e) => e !== null)}
            />
          ))}
        </Flex>
      </Flex>
    )
  })
}

export { FormRender }
